import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Divider, Grid2, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useGetAllRiskOpenCloseQuery } from '../../../store/slices/apis/riskDashboardSlice';
import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import ExportToExcel from './ExportToExcel';
import ExportToPDF from './ExportToPDF';


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));

export default function RiskPopup({ title, value, status, onClose, onOpen }) {

    const theme = useTheme();
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);

    let searchparams = {
        projectId: projectId,
        page: pageNumber,
        pageSize: 10,
        sortBy: 'createddate',
        sortOrder: 'desc',
        approved_status: 'Approved',
    }

    if (status == 'HeatMatrix') {
        const [likelihoodScore, impactScoreOverall] = value.split(',');
        searchparams = {
            projectId: projectId,
            page: pageNumber,
            pageSize: 10,
            likelihoodScore: likelihoodScore,
            impactScoreOverall: impactScoreOverall,
            endpoint: 'risk/filter-by-heatmatrix',
        }
    }
    else if (status == 'Inherent') {
        searchparams = {
            ...searchparams,
            inherent: true,
        }
    }
    else if (status == 'Unmitigated') {
        searchparams = {
            ...searchparams,
            mitigation: 'empty',
            'status': 'Open',
        }
    }
    else if (status == 'WithActions') {
        searchparams = {
            ...searchparams,
            mitigation: 'non-empty',
            'status': 'Open',
        }
    }
    else if (status == 'severity') {
        searchparams = {
            ...searchparams,
            severity: value,
            'status': 'Open',
        }
    }
    else if (status == 'package') {
        searchparams = {
            ...searchparams,
            package: value,
            'status': 'Open',
        }
    }
    else if (status == 'dateRange') {
        const [from, to] = value.split(',');

        searchparams = {
            ...searchparams,
            from: from,
            to: to,
        }
    }
    else {
        searchparams = {
            ...searchparams,
            status: status,
        }
    }

    const { data: openCloseData = [], error: openCloseError, isLoading: isOpenCloseLoading } = useGetAllRiskOpenCloseQuery(
        searchparams
    );

    // Export complete data in PDF / Excel
    const searchparamsexport = {
        ...searchparams,
        page: 1,
        pageSize: 1000,
    }

    const { data: openCloseDataExport = [], error: openCloseExportError, isLoading: isOpenCloseExportLoading } = useGetAllRiskOpenCloseQuery(
        searchparamsexport);
    // Export complete data in PDF / Excel

    const columns = [
        {
            name: "Risk No.",
            field: "risk_number",
        },
        {
            name: "Consultant/Contractor",
            field: "contrctorname",
        },
        {
            name: "Package",
            field: "package",
        },
        {
            name: "Risk Category",
            field: "risk_category",
        },
        {
            name: "Risk Description",
            field: "risk_description",
        },
        {
            name: "Status",
            field: "status",
        },
        {
            name: "Likelihood Score",
            field: "likelihood_score",
        },
        {
            name: "Impact Score",
            field: "impact_score_overall",
        },
        {
            name: "Risk Score",
            field: "risk_score",
        },
        {
            name: "Mitigation",
            field: "mitigation",
        },
        {
            name: "Severity",
            field: "severity",
        },
        {
            name: "Created Date",
            field: "createddate",
            renderer(params) {
                return (
                    <>
                        {params?.createddate
                            ? moment(params.createddate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
            //renderExport: (row) => new Date(row.createdAt).toLocaleDateString(),
            renderExport: (params) => moment(params.createddate).format("DD/MM/YYYY"),
        },
    ]
    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={openCloseDataExport?.data} columns={columns} fileName="exportexcel_table" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={openCloseDataExport?.data} columns={columns} fileName="exportpdf_table" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={openCloseData?.data} isLoading={isOpenCloseLoading} />

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.pagination?.currentPage || 1}
                                        totalPages={openCloseData?.pagination?.totalPages || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>

                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}